import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { apiRequest } from "src/async/apiUtils";
import { logoutRedirect } from "src/async/fetch";
import Preloader from "src/components/shared/LoadingAnimations/Preloader";
import { useUpdateSocketToken } from "src/context/SocketContext";
import { getNavigateLink } from "src/helpers/userHelper";

const SSOLogin = () => {
  const navigate = useNavigate();
  const updateSocketToken = useUpdateSocketToken();

  const clickWorkspace = async () => {
    try {
      const { data: resData } = await apiRequest("GET", `/portal/users/workspaces/page`);

      if (resData.status === 200) {
        const navigate_link = getNavigateLink(resData);
        navigate(navigate_link);
      } else {
        navigate("/permission-denied");
      }
    } catch (err) {
      navigate("/permission-denied");
    }
  };

  const loadUser = async () => {
    const accessToken = new URLSearchParams(window.location.search).get("access_token");
    const refreshToken = new URLSearchParams(window.location.search).get("refresh_token");

    if (!accessToken) logoutRedirect();

    try {
      localStorage.setItem("accessToken", accessToken);
      localStorage.setItem("refreshToken", refreshToken);
      updateSocketToken(accessToken);
      window.postMessage(
        {
          type: "LOGIN_SUCCESS",
          token: accessToken,
        },
        "*",
      );

      const res = await apiRequest(
        "post",
        "/portal/users/self/details",
        {
          body: {
            token: accessToken,
            access_token: accessToken,
          },
        },
        { returnErrorWithstatus: true }
      );

      const resData = res?.data;

      if (resData?.status === "client_inactive" || resData?.status === "inactive" || resData?.status === 403) {
        navigate("/client-inactive");
        return;
      }

      if (resData?.status !== 200) {
        logoutRedirect();
        return;
      }

      localStorage.setItem("email", resData?.email);
      localStorage.setItem("isSubDomain", resData?.isSubDomain);
      await clickWorkspace();
    } catch (error) {
      if (
        error?.response?.data?.status === "client_inactive" ||
        error?.response?.data?.status === "inactive" ||
        error?.response?.status === 403 ||
        error?.data?.status === "client_inactive" ||
        error?.status === 403
      ) {
        navigate("/client-inactive");
        return;
      }
      if (error?.message !== "Failed to fetch" && error?.message !== "The user aborted a request.") {
        logoutRedirect();
      }
    }
  };

  useEffect(() => {
    loadUser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [window.location.search]);

  return (
    <div className="flex h-full items-center justify-center">
      <Preloader />
    </div>
  );
};

export default SSOLogin;
